const SET_USER_INFO = 'SET_USER_INFO';
const SET_USER_PERMISSION = 'SET_USER_PERMISSION';
const SIGN_OUT = 'SIGN_OUT';

export default {
    SET_USER_INFO,
    SET_USER_PERMISSION,
    SIGN_OUT
}